export default __webpack_public_path__ + "static/media/fisheriesAquaculture.58adc914.svg";